export default __webpack_public_path__ + "static/media/rewards.9b631354.svg";